<div class="flex column center justify-center">
	<i class="fa-solid fa-circle-notch fa-spin fa-2xl white"></i>
</div>
